<template>
	<div class="workflow">
		<!-- 搜索栏 -->
		<div class="search-bar">
			<div class="search-left">
				<el-input v-model="queryParams.name" placeholder="智能体名称" style="width: 200px; margin-right: 10px;"
					clearable></el-input>

				<el-select v-model="queryParams.aiTypeCode" placeholder="请选择类型"
					style="width: 150px; margin-right: 10px;" clearable>
					<el-option v-for="item in ModelTypeList" :key="item.typeCode" :label="item.typeName"
						:value="item.typeCode" />
				</el-select>
				<el-select v-if="isAdmin" v-model="queryParams.isAdmin" placeholder="请选择查询类型"
					style="width:150px;margin-right:10px" clearable @change="fetchData">
					<el-option v-for="item in adminlist" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-button type="primary" icon="el-icon-search" @click="fetchData">搜索</el-button>
			</div>
			<el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增标准模型</el-button>
		</div>

		<!-- 数据表格 -->
		<el-table :data="tableData" border style="width: 100%; margin-top: 20px;">
			<el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
			<el-table-column prop="name" label="智能体名称" width="200" align="center"></el-table-column>

			<el-table-column label="类型" width="120" align="center">
				<template slot-scope="scope">
					<el-tag type="primary">
						{{ (ModelTypeList.find(item => item.typeCode === scope.row.aiTypeCode) || {}).typeName || scope.row.aiTypeCode }}
					</el-tag>
				</template>
			</el-table-column>

			<el-table-column prop="description" label="描述" show-overflow-tooltip align="center"></el-table-column>
			<el-table-column prop="params" label="参数JSON" width="180" show-overflow-tooltip
				align="center"></el-table-column>

			<el-table-column prop="status" label="状态" width="100" align="center">
				<template slot-scope="scope">
					<el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
						{{ scope.row.status === 0 ? '启用' : '禁用' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" width="180" align="center">
				<template slot-scope="scope">
					{{ formatTime(scope.row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column label="操作" fixed="right" width="250" align="center">
				<template slot-scope="scope">
					<el-button size="mini" v-if="scope.row.userId==userId" @click="handleEdit(scope.row)">编辑</el-button>
					<el-button size="mini" v-if="scope.row.userId!=userId" @click="handleEdit(scope.row)">查看</el-button>
					<el-button size="mini" v-if="scope.row.userId==userId" type="warning"
						@click="handleStatus(scope.row)">
						{{ scope.row.status === 0 ? '禁用' : '启用' }}
					</el-button>
					<el-button size="mini" v-if="scope.row.userId==userId" type="danger"
						@click="handleDelete(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="queryParams.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"
			style="margin-top: 20px; text-align: right;">
		</el-pagination>

		<!-- 新增/编辑弹窗 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px">
			<el-form :model="allForm" :rules="formRules" ref="formRef" label-width="140px" @submit.native.prevent>

				<el-form-item label="模型类型" prop="form.aiTypeCode">
					<el-select v-model="allForm.form.aiTypeCode" placeholder="请选择模型类型" style="width: 100%;" clearable
						@change="loadConfigFields" :disabled="bodArr!=null">
						<el-option v-for="item in ModelTypeList.filter(v=>v.status==0&&v.isDeleted==0)"
							:key="item.typeCode" :label="item.typeName" :value="item.typeCode" />
					</el-select>
				</el-form-item>

				<el-form-item label="模型名称" prop="form.name">
					<el-input v-model="allForm.form.name" placeholder="请输入模型名称"></el-input>
				</el-form-item>

				<!-- 两张图片同一行布局 -->
				<div v-if="isAgentSquare" class="upload-row-wrap">
					<!-- 展示图 -->
					<el-form-item label="展示图" prop="form.promotionalImage" class="upload-col">
						<!-- 无图：上传框 -->
						<template v-if="!allForm.form.promotionalImage">
							<el-upload :http-request="handleViewLocalUpload" :file-list="agentViewFileList"
								list-type="picture-card" :on-remove="handleViewRemove" :limit="1" action="#">
								<i class="el-icon-plus"><span style="font-size: 12px;"><br>仅支持jpg/png</span></i>
							</el-upload>
						</template>
						<!-- 有图：自定义图片预览，hover才出现删除 -->
						<template v-else>
							<div class="picture-card-single">
								<el-image :src="agentViewFileList[0].url" fit="cover"></el-image>
								<i class="el-icon-delete del-icon" @click="handleViewRemove"></i>
							</div>
						</template>
					</el-form-item>

					<!-- 智能体/工作流页图 统一改成上面逻辑 -->
					<el-form-item label="智能体/工作流页图" prop="form.designDrawing" class="upload-col ">
						<template v-if="!allForm.form.designDrawing">
							<el-upload :http-request="handleWorldLocalUpload" :file-list="agentWorldFileList"
								list-type="picture-card" :on-remove="handleWorldRemove" :limit="1" action="#">
								<i class="el-icon-plus"><span style="font-size: 12px;"><br>仅支持jpg/png</span></i>
							</el-upload>
						</template>
						<template v-else>
							<div class="picture-card-single">
								<el-image :src="agentWorldFileList[0].url" fit="cover"></el-image>
								<i class="el-icon-delete del-icon" @click="handleWorldRemove"></i>
							</div>
						</template>
					</el-form-item>
				</div>

				<el-form-item label="描述" prop="form.description">
					<el-input v-model="allForm.form.description" type="textarea" :rows="3"
						placeholder="请输入描述"></el-input>
				</el-form-item>
				<el-form-item label="Html网页" prop="form.htmlSrc" v-if="allForm.form.aiTypeCode=='html'">
					<div v-if="allForm.form.htmlId">
						<span v-if="allForm.form.htmlName">{{allForm.form.htmlName}}</span>
						<button size="mini" @click="clearFiler">重置</button>
					</div>
					<div v-else>
						<input type="file" accept=".html" @change="handleUploadHtml" v-if="!file" />
						<!-- <button v-if="value.htmlList[0].src" size="mini" @click="clearFile">重新选择</button> -->
						<template v-else>
							<span>已选：{{ uploadFileName }}</span>
							<button size="mini" @click="clearFile">重新选择</button>
						</template>
					</div>
					<button v-if="allForm.form.htmlSrc||processedHtml" @click="viewHtml">模拟测试</button>
					<button v-if="(allForm.form.htmlSrc||processedHtml)&&htmlSimulation" class="html-config-btn"
						@click="viewHtmlConfig">HTML页面配置</button>
					<span v-if="isClear" style="color: red;font-size: 13px;">*保存后将更新所有使用的课堂文件,请谨慎修改</span>
				</el-form-item>

				<!-- 动态配置字段 -->
				<template v-if="dynamicFields.length > 0">
					<div style="border-top:1px dashed #eee; padding:15px 0; margin:10px 0;">
						<div style="font-weight:600; margin-bottom:12px;"><i class="el-icon-s-tools" />接口参数配置</div>
						<el-form-item v-for="item in dynamicFields" :key="item.field" :label="item.label"
							:prop="`dynamicForm.${item.field}`" :rules="[{
				        required: item.required === 'true',
				        message: `请设置${item.label}`,
				        trigger: 'change'
				      }]">
							<!-- 自定义label插槽，label文字+问号同行 -->
							<template slot="label">
								{{ item.label }}
								<span v-if="item.remark" :title="item.remark" style="
				            display: inline-flex;
				            align-items: center;
				            justify-content: center;
				            width: 16px;
				            height: 16px;
				            border-radius: 50%;
				            background: #eee;
				            color: #999;
				            font-size: 12px;
				            cursor: pointer;
				            margin-left: 6px;
				            vertical-align: middle;
				          ">?</span>
							</template>

							<el-input v-if="item.type === 'input'" v-model="allForm.dynamicForm[item.field]"
								:placeholder="`请输入${item.label}`" :disabled="bodArr!=null&&(item.field=='botId'||item.field=='workflowId')">

							</el-input>
							<el-input v-else-if="item.type === 'textarea'" v-model="allForm.dynamicForm[item.field]"
								type="textarea" :rows="3" :placeholder="`请输入${item.label}`" />
							<el-slider v-else-if="item.type === 'slider'" v-model="allForm.dynamicForm[item.field]"
								:min="(parseFloat(item.min))" :max="(parseFloat(item.max))" :step="0.01" show-input />
							<el-switch v-else-if="item.type === 'boolean'" v-model="allForm.dynamicForm[item.field]"
								:active-value="1" :inactive-value="0" />
							<el-input v-else v-model="allForm.dynamicForm[item.field]"
								:placeholder="`请输入${item.label}`" />
						</el-form-item>
					</div>
				</template>

				<el-form-item label="状态" prop="form.status" v-if="dialogVisible">
					<el-radio-group v-model="allForm.form.status">
						<el-radio :label="0">启用</el-radio>
						<el-radio :label="1">禁用</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<div v-if="(allForm.form.userId==userId&&allForm.form.id)||!allForm.form.id"><el-button
						@click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="handleSubmit">确 定</el-button>
				</div>
				<div v-else><el-button @click="dialogVisible = false">关 闭</el-button></div>
			</span>
		</el-dialog>
		<!-- 2026-07-29 HTML 配置弹窗：子组件关闭时仍走既有 handleCloseDialog，保证退出流程一致。 -->
		<el-dialog :title="htmlConfigMode ? 'HTML页面配置' : '网页智能体模拟'" :visible.sync="isHtml" width="100%" top="0"
			:before-close="handleCloseDialog" :modal-append-to-body="true" style="overflow-y: hidden;height:100%;">
			<div style=" width:100%;height:calc(100vh - 120px);">
				<HtmlPlayView :key="dialogKey" :url="htmlSrc" :iframeUrlOrigin="iframeUrlOrigin"
					:iframeUrlPlay="iframeUrlPlay" :configMode="htmlConfigMode"
					:htmlUploadRecordId="currentHtmlUploadRecordId" :layerConfig.sync="htmlLayerConfigDraft"
					@save-layer-config="handleLayerConfigSave" @close-config="handleCloseDialog" />
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		ModelUploadParam,
		HtmlToOss,
		injectCubePostMessage
	} from "@/js/img.js"
	import HtmlPlayView from '@/views/components/html/HtmlIframeView.vue'
	export default {
		name: 'StandardModel',
		components: {
			HtmlPlayView
		},
		computed: {
			currentHtmlUploadRecordId() {
				// 2026-07-17 HTML stratified config: use upload record id first, then compatible legacy html id.
				return this.pickHtmlUploadRecordId(this.allForm.form)
			}
		},
		data() {
			return {
				ModelTypeList: [],
				userId: localStorage.getItem('userId'),
				tableData: [],
				total: 0,
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					name: '',
					aiTypeCode: null,
					status: null,
					isAdmin: 0,
				},
				file: null,
				uploadFileName: null,
				dialogVisible: false,
				dialogTitle: '',
				allForm: {
					form: {
						id: null,
						name: '',
						htmlName: '',
						htmlSrc: null,
						htmlId: null,
						htmlUploadRecordId: null,
						aiTypeCode: '',
						description: '',
						params: '',
						status: 0,
						min: 0.01,
						max: 1,
						promotionalImage: '',
						designDrawing: '',
					},
					dynamicForm: {}
				},
				htmlSrc: '',
				dynamicFields: [],
				baseRules: {
					'form.name': [{
						required: true,
						message: '请输入模型名称',
						trigger: 'blur'
					}],
					'form.aiTypeCode': [{
						required: true,
						message: '请选择模型类型',
						trigger: 'change'
					}],
					'form.description': [{
						required: true,
						message: '请输入描述',
						trigger: 'blur'
					}],
					'form.htmlSrc': [{
						required: true,
						message: '请上传html文件',
						trigger: 'blur'
					}]
				},
				formRules: {},
				isAdmin: false,
				adminlist: [{
						value: 0,
						label: "仅自己"
					},
					{
						value: 1,
						label: "全校"
					},
				],
				isAgentSquare: false,
				agentViewFileList: [{
					url: ''
				}],
				agentWorldFileList: [{
					url: ''
				}],
				viewLocalUrl: '',
				worldLocalUrl: '',
				login: null,
				iframeUrlOrigin: null,
				iframeUrlPlay: null,
				processedHtml: null,
				isHtml: false,
				htmlConfigMode: false,
				htmlLayerConfigDraft: [],
				htmlSimulation: false,
				dialogKey: 1,
				isClear: false,
				bodArr: null,
			}
		},
		methods: {
			pickHtmlUploadRecordId(source = {}) {
				if (!source) return ''
				if (typeof source === 'number' || typeof source === 'string') return source
				const data = source.data !== undefined ? source.data : source
				if (!data) return ''
				if (typeof data === 'number' || typeof data === 'string') return data
				return data.htmlUploadRecordId || data.htmlUploadId || data.uploadRecordId || data.recordId || data
					.htmlId || ''
			},
			forHtmlSimulation() {

				this.htmlSimulation = false
				const MenuList = localStorage.getItem('MenuList')
				if (MenuList) {
					if (MenuList.includes('htmlSimulation')) {
						this.htmlSimulation = true
					}
				}
				if (localStorage.getItem('userType') == 1) {
					this.htmlSimulation = true
				}
			},
			clearFiler() {
				this.allForm.form.htmlId = null
				this.allForm.form.htmlUploadRecordId = null
				this.allForm.form.htmlSrc = null
				this.processedHtml = null
				this.uploadFileName = ''
				this.htmlLayerConfigDraft = []
				this.isClear = true
			},
			clearFile() {
				this.file = null
				this.processedHtml = null
				this.allForm.form.htmlName = ''
				this.allForm.form.htmlSrc = null
				this.allForm.form.htmlUploadRecordId = null
				this.htmlLayerConfigDraft = []
			},
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			async uploadHtmlFile(id) {

				if (!this.processedHtml) return


				if (this.login) {
					this.login.text = '文件上传中...'
				} else {
					this.loginOpen('文件上传中...')
				}

				try {
					const file = new File([this.processedHtml], this.uploadFileName, {
						type: "text/html;charset=utf-8",
						lastModified: Date.now()
					});


					const res = await HtmlToOss(file, 1, id)
					// 2026-07-17 HTML stratified config: cache upload record id returned by html save for rule query/render.
					const htmlUploadRecordId = this.pickHtmlUploadRecordId(HtmlToOss.lastResult) || HtmlToOss
						.lastHtmlUploadRecordId
					if (htmlUploadRecordId) {
						this.$set(this.allForm.form, 'htmlUploadRecordId', htmlUploadRecordId)
					}
					console.log('res', res)
					// return 
					if (res !== '') {
						this.processedHtml = null
						this.uploadFileName = ''
						this.$message.success('HTML上传成功');
						this.fetchData()

					}
				} catch (err) {
					console.error('上传失败', err)
				} finally {
					this.noLogin()
				}
			},
			async htmlToBlod() {
				try {
					let rawHtml = await this.file.text();
					this.processedHtml = injectCubePostMessage(rawHtml);
					this.allForm.form.htmlSrc = 'blod'
					// 释放旧blob内存
					if (this.iframeUrlOrigin) URL.revokeObjectURL(this.iframeUrlOrigin);
					if (this.iframeUrlPlay) URL.revokeObjectURL(this.iframeUrlPlay);
					// if (this.cachePlaySnapshot) URL.revokeObjectURL(this.cachePlaySnapshot);

					const blob = new Blob([this.processedHtml], {
						type: "text/html;charset=utf-8"
					});
					this.iframeUrlOrigin = URL.createObjectURL(blob);
					this.iframeUrlPlay = URL.createObjectURL(blob);
				} catch (err) {

				}
			},
			async viewHtml() {
				this.htmlConfigMode = false
				// if (!this.iframeUrlOrigin&&!this.isSrc) {
				// 	this.$message.warning('请先上传HTML文件');
				// 	return;
				// }
				if (this.allForm.form.htmlId && this.allForm.form.htmlSrc) {
					await this.loadOssHtml(this.allForm.form.htmlSrc)
					this.$nextTick()
					this.dialogKey += 1;
					this.isHtml = true;
				} else {
					if (!this.file) this.$message.warning('请先上传HTML文件');
					await this.htmlToBlod()
					this.$nextTick()
					this.dialogKey += 1;
					this.isHtml = true;
				}

			},
			async viewHtmlConfig() {
				this.htmlConfigMode = true
				if (this.allForm.form.htmlId && this.allForm.form.htmlSrc) {
					await this.loadOssHtml(this.allForm.form.htmlSrc)
					this.$nextTick()
					this.dialogKey += 1;
					this.isHtml = true;
				} else {
					if (!this.file) return this.$message.warning('请先上传HTML文件');
					await this.htmlToBlod()
					this.$nextTick()
					this.dialogKey += 1;
					this.isHtml = true;
				}
			},
			handleCloseDialog() {
				if (this.iframeUrlOrigin) URL.revokeObjectURL(this.iframeUrlOrigin);
				if (this.iframeUrlPlay) URL.revokeObjectURL(this.iframeUrlPlay);

				this.htmlConfigMode = false;
				this.isHtml = false;
			},
			handleLayerConfigSave(payload) {
				this.htmlLayerConfigDraft = this.normalizeHtmlLayerConfig(payload)
			},
			getParsedParams(params) {
				if (!params) return {}
				if (typeof params === 'object') return params
				try {
					return JSON.parse(params)
				} catch (e) {
					return {}
				}
			},
			normalizeHtmlLayerConfig(config) {
				if (!Array.isArray(config)) return []
				// 兼容旧 params.htmlLayerConfig 草稿，只保留后端和回放需要的字段。
				return config
					.filter(item => item && item.name)
					.map((item, index) => ({
						layerId: item.layerId || item.id || '',
						ruleId: item.ruleId || item.serverId || 0,
						name: String(item.name || '').trim(),
						sort: item.sort || index + 1,
						steps: Array.isArray(item.steps) ? item.steps.map((step, stepIndex) => ({
							sort: step.sort || stepIndex + 1,
							funcName: step.funcName || '',
							targetId: step.targetId || '',
							name: step.name || step.targetId || step.funcName || '页面操作',
							args: Array.isArray(step.args) ? step.args : [],
							timestamp: step.timestamp || step.operateTimestamp || Date.now()
						})) : []
					}))
					.filter(item => item.steps.length > 0)
			},
			async loadOssHtml(src) {
				let oss = await this.$oss.getDownloadUrl(src)
				this.htmlSrc = oss
				try {
					// 批量释放全部旧blob，防止浏览器回收空白页面
					const releaseBlob = (url) => {
						if (url && url.startsWith('blob:')) URL.revokeObjectURL(url);
					}
					releaseBlob(this.iframeUrlOrigin);
					releaseBlob(this.iframeUrlPlay);
					const blobUrl = await this.loadOssHtmlBlob(oss)
					// this.iframeSrc = URL.createObjectURL(blobUrl);
					this.iframeUrlOrigin = URL.createObjectURL(blobUrl);
					this.iframeUrlPlay = URL.createObjectURL(blobUrl);
					this.$message.success('网页智能体加载完成')
				} catch (err) {
					this.$message.error('读取OSS失败：' + err.message)
					console.error(err)
				}
			},
			async loadOssHtmlBlob(ossUrl) {
				try {
					const res = await fetch(ossUrl, {
						method: "GET",
						mode: "cors"
					});
					if (!res.ok) {
						throw new Error(`OSS请求失败，状态码：${res.status}，链接过期/无跨域权限`);
					}
					const rawBlob = await res.blob();
					const htmlBlob = new Blob([rawBlob], {
						type: "text/html;charset=utf-8"
					});
					// const blobUrl = 
					return htmlBlob;
				} catch (err) {
					this.$message.error('读取OSS失败：' + err.message);
					console.error(err);
					return ''
				}
			},
			async handleUploadHtml(e) {

				const file = e.target.files[0];

				if (!file) return;
				this.file = file
				this.uploadFileName = this.file.name;
				this.loginOpen('网页文件处理中...')
				try {
					// 更新文件信息
					this.allForm.form.htmlName = this.uploadFileName;
					this.allForm.form.htmlSrc = null
					this.htmlToBlod()

				} catch (error) {
					console.error('HTML解析失败', error)
					this.allForm.form.htmlSrc = null
					this.allForm.form.htmlName = ''
				} finally {
					this.noLogin()
				}
			},
			setFormRules() {
				this.formRules = {
					...this.baseRules
				}
				if (this.isAgentSquare) {
					this.formRules['form.promotionalImage'] = [{
						required: true,
						message: '请上传展示图',
						trigger: 'change'
					}]
					this.formRules['form.designDrawing'] = [{
						required: true,
						message: '请上传智能体/工作流页图',
						trigger: 'change'
					}]
				} else {
					delete this.formRules['form.promotionalImage']
					delete this.formRules['form.designDrawing']
				}
				if (this.allForm.form.aiTypeCode == 'html') {
					this.formRules['form.htmlSrc'] = [{
						required: true,
						message: '请上传Html文件',
						trigger: 'change'
					}]
				} else {
					delete this.formRules['form.htmlId']

				}

			},
			async info() {
				try {
					if (localStorage.getItem('userType') == 2) {
						let str = localStorage.getItem('userInfo')
						let list = JSON.parse(str)
						this.isAdmin = list.filter(v => v.roleType == 2).length > 0 ? true : false
					} else {
						this.isAdmin = false
					}
				} catch (error) {
					this.isAdmin = false
				}
			},
			async forModelTypeList() {
				try {
					let res = await this.API.get(this.API.admin.getModelTypeList, {
						pageNum: 1,
						pageSize: 100
					})
					this.ModelTypeList = res.data.data.records || []
				} catch {
					this.ModelTypeList = []
				}
			},
			formatTime(timestamp) {
				if (!timestamp) return ''
				return new Date(timestamp).toLocaleString()
			},
			async fetchData() {

				try {
					const res = await this.API.get(this.API.admin.getStandardModelList, this.queryParams)
					this.tableData = res.data.data.records || []
					this.total = res.data.data.total || 0
				} catch (e) {
					this.tableData = []
					this.total = 0
				} finally {
					if (localStorage.getItem("bodArr")||localStorage.getItem("workflowArr")) {
						this.forBodArr()
					}
					
				}
			},
			//通过密钥添加归属的智能体
			forBodArr() {
				this.loginOpen('处理扣子智能体数据中...')
				
				let bodArrStr = localStorage.getItem("bodArr")||localStorage.getItem("workflowArr")
				var isCode=localStorage.getItem("bodArr")?2:localStorage.getItem("workflowArr")?1:''
				this.bodArr = JSON.parse(bodArrStr)
				
				this.isClear = false
				this.dialogTitle = '新增标准智能体';
				this.allForm.form = {
					id: null,
					name: isCode==1?this.bodArr.workflow_detail.workflow_name:isCode==2?this.bodArr.name:"",
					aiTypeCode:isCode==1?"coze_flow":isCode==2?"coze_bot":'',
					description: this.bodArr.description||this.bodArr.workflow_detail.description,
					params: '',
					status: 0,
					htmlName: '',
					htmlSrc: null,
					htmlId: null,
					htmlUploadRecordId: null,
					promotionalImage: this.bodArr.icon_url||this.bodArr.workflow_detail.icon_url,
					designDrawing: '',
				};
				this.agentWorldFileList = [];
				this.agentViewFileList[0].url = this.bodArr.icon_url||this.bodArr.workflow_detail.icon_url
				this.setFormRules()
				if (localStorage.getItem('userType') == 1) {
					// this.isAgentSquare = true
				}
				this.dialogVisible = true;
				if(isCode==2){
					this.loadConfigFields("coze_bot")
				}
				if(isCode==1){
					this.loadConfigFields("coze_flow")
				}
				this.$nextTick(() => {
					if(isCode==2){
						this.allForm.dynamicForm.botId = this.bodArr.bot_id
					}
					if(isCode==1){
						this.allForm.dynamicForm.workflowId=this.bodArr.workflow_detail.workflow_id 
						if(this.bodArr.workflow_detail.app_id!=0){
							this.allForm.dynamicForm.botId=this.bodArr.workflow_detail.app_id
						}
						if(this.bodArr.input){
							var input=''
							if(this.bodArr?.input?.parameters){
								input=JSON.stringify(this.bodArr.input.parameters)
							}
							this.allForm.dynamicForm.input=input
						}
						if(this.bodArr.output){
							//this.allForm.dynamicForm.output =this.bodArr?.output?.parameters||{}use_answer_content非流式   return_variables变量返回
							// if(this.bodArr?.output?.terminate_plan){
							// 	this.allForm.dynamicForm.stream=this.bodArr.output.terminate_plan=='return_variables'?false:
							// }
							
						}
					}
					this.noLogin()

				})
			},
			handleAdd() {
				if (this.bodArr) {
					this.bodArr = null
					if(localStorage.getItem("bodArr")){
						localStorage.removeItem("bodArr")
					}
					if(localStorage.getItem("workflowArr")){
						localStorage.removeItem("workflowArr")
					}
				}
				this.isClear = false
				this.dialogTitle = '新增标准智能体';
				this.allForm.form = {
					id: null,
					name: '',
					aiTypeCode: '',
					description: '',
					params: '',
					status: 0,
					htmlName: '',
					htmlSrc: null,
					htmlId: null,
					htmlUploadRecordId: null,
					promotionalImage: '',
					designDrawing: '',
				};
				this.processedHtml = null
				this.uploadFileName = ''
				this.htmlLayerConfigDraft = []
				this.allForm.dynamicForm = {};
				this.dynamicFields = [];
				this.agentViewFileList = [];
				this.agentWorldFileList = [];
				if (this.viewLocalUrl) URL.revokeObjectURL(this.viewLocalUrl);
				if (this.worldLocalUrl) URL.revokeObjectURL(this.worldLocalUrl);
				this.viewLocalUrl = '';
				this.worldLocalUrl = '';
				this.setFormRules()
				this.dialogVisible = true;
			},
			async handleEdit(row) {
				this.loginOpen('数据加载中...')
				try {
					this.isClear = false
					this.dialogTitle = '编辑标准模型';
					const parsedParams = this.getParsedParams(row.params)
					this.htmlLayerConfigDraft = this.normalizeHtmlLayerConfig(parsedParams.htmlLayerConfig)
					this.allForm.form = {
						...row
					};
					this.allForm.dynamicForm = {};
					this.dynamicFields = [];
					this.agentViewFileList = [{
						url: ''
					}];
					if (this.allForm.form.promotionalImage && this.allForm.form.promotionalImage.includes('.png')) {

						let promotionalImage = await await this.$oss.getDownloadUrl(this.allForm.form.promotionalImage)

						this.agentViewFileList = [{
							url: promotionalImage
						}]
						//this.allForm.form.promotionalImage = promotionalImage
					}
					this.agentWorldFileList = [{
						url: ''
					}];
					if (this.allForm.form.designDrawing && this.allForm.form.designDrawing.includes('.png')) {
						let designDrawing = await this.$oss.getDownloadUrl(this.allForm.form.designDrawing)
						//this.allForm.form.designDrawing = designDrawing
						this.agentWorldFileList = [{
							url: designDrawing
						}]
					}
					if (this.viewLocalUrl) URL.revokeObjectURL(this.viewLocalUrl);
					if (this.worldLocalUrl) URL.revokeObjectURL(this.worldLocalUrl);
					this.viewLocalUrl = '';
					this.worldLocalUrl = '';
					this.setFormRules()
					this.dialogVisible = true;
					if (row.aiTypeCode) {
						this.$nextTick(() => {
							this.loadConfigFields(row.aiTypeCode);
							this.dynamicFields = this.dynamicFields.map(item => {
								if (item.type === 'slider') {
									let min = parseFloat(item.min) || 0;
									let max = parseFloat(item.max) || 1;
									if (min > max)[min, max] = [max, min];
									return {
										...item,
										min,
										max
									};
								}
								return item;
							});
							if (row.params) {
								this.dynamicFields.forEach(field => {
									const val = parsedParams[field.field];
									if (val === undefined) return;
									if (field.type === 'slider') {
										this.allForm.dynamicForm[field.field] = parseFloat(val);
									} else if (field.type === 'boolean') {
										this.allForm.dynamicForm[field.field] = Number(val);
									} else {
										this.allForm.dynamicForm[field.field] = val;
									}
								});
							}
						});
					}
				} catch (e) {

				} finally {
					this.noLogin()
				}
			},
			loadConfigFields(typeCode) {
				this.dynamicFields = [];
				this.allForm.dynamicForm = {};
				const item = this.ModelTypeList.find(m => m.typeCode === typeCode);
				
				if (!item || !item.configFields) return;
				const MenuList = localStorage.getItem('MenuList')
				if (MenuList) {
					this.isAgentSquare = MenuList.includes('IntelligentAgentSquare')
				}
				console.log('typeCode',typeCode)
				if(typeCode==='volc'){
					this.isAgentSquare=false
				}
				try {
					this.dynamicFields = JSON.parse(item.configFields);
					this.dynamicFields.forEach(field => {
						let value;
						if (field.type === 'slider') value = parseFloat(field.value || 0);
						else if (field.type === 'boolean') value = Number(field.value || 0);
						else value = field.value || '';
						this.$set(this.allForm.dynamicForm, field.field, value);
					});
				} catch (e) {
					this.dynamicFields = [];
				}
			},
			async handleSubmit() {
				this.$refs.formRef.validate(async valid => {
					if (!valid) return;
					const data = {
						...this.allForm.dynamicForm
					};
					this.dynamicFields.forEach(f => {
						if (f.type === 'slider') data[f.field] = String(data[f.field]);
					});
					const submitData = {
						...this.allForm.form
					};
					if (submitData.aiTypeCode == 'html' && !submitData.htmlSrc) return this.$message
						.success('请上传网页')
					if (this.processedHtml) {
						delete submitData.htmlSrc;
					}
					// 2026-07-29 标准模型提交：分层规则已由 html/stratified/rules/sync 独立保存。
					// 不再把完整录制步骤重复写入 params，避免多规则时模型更新请求过大而报 500。
					submitData.params = JSON.stringify(data);
					// console.log('submitData',submitData)
					if(this.bodArr){
						submitData.aiParams=JSON.stringify(this.bodArr)
					}
					// return
					try {
						if (this.allForm.form.id) {
							this.loginOpen('修改中...')
							await this.API.put(this.API.admin.putStandardModelUpdate, submitData);
							await this.imgType(submitData)

							await this.uploadHtmlFile(submitData.id)
							this.$message.success('修改成功');
						} else {
							this.loginOpen('保存中...')
							let res = await this.API.post(this.API.admin.postStandardModelAdd, submitData);
							submitData.id = res.data.data
							await this.imgType(submitData)

							await this.uploadHtmlFile(submitData.id)
							this.$message.success('新增成功');
							
						}
						this.dialogVisible = false;
						this.fetchData();
					} catch (err) {
						console.error('标准智能体保存失败', {
							err,
							paramsLength: submitData.params ? submitData.params.length : 0,
							params: submitData.params
						})
						this.$message.error(err?.msg || err?.message || '保存失败，请检查参数JSON或后端日志')
					} finally {
						if (this.bodArr) {
							this.bodArr = null
							if(localStorage.getItem("bodArr")){
								localStorage.removeItem("bodArr")
							}
							if(localStorage.getItem("workflowArr")){
								localStorage.removeItem("workflowArr")
							}
						}
						this.noLogin()
					}
				});
			},
			async imgType(submitData) {
				if (this.isAgentSquare) {

					if (submitData.promotionalImage?.includes("blob:")) {
						if (this.login) {
							this.login.text = '图片保存中...'
						} else {
							this.loginOpen('图片保存中...')
						}
						//存在本地图片
						let toimg = await this.postModelResourceAdd(submitData, 1, submitData.promotionalImage)
						if (toimg == "false") {
							this.$message.error('上传展示图失败')
						}
					}

					if (submitData.designDrawing?.includes("blob:")) {
						if (this.login) {
							this.login.text = '图片保存中...'
						} else {
							this.loginOpen('图片保存中...')
						}
						//存在本地图片designDrawing‌
						let toimgs = await this.postModelResourceAdd(submitData, 2, submitData.designDrawing)
						if (toimgs == "false") {
							this.$message.error('上传智能体/工作流页图失败')
						}
					}
				}
			},
			async postModelResourceAdd(submitData, type, blobUrl) {
				try {

					let src = await ModelUploadParam(blobUrl, submitData, type)
					return true
				} catch (err) {
					return false
				}
			},
			async handleStatus(row) {
				const newStatus = row.status === 0 ? 1 : 0;
				await this.API.put(this.API.admin.putStandardModelStatus + `/${row.id}?status=${newStatus}`);
				row.status = newStatus;
				this.$message.success('状态已更新');
			},
			async handleDelete(row) {
				this.$confirm('确定删除该标准智能体配置？', '提示', {
					type: 'warning'
				}).then(async () => {
					await this.API.deleted(this.API.admin.deleteStandardModelRemove + `/${row.id}`);
					this.$message.success('删除成功');
					this.fetchData();
				}).catch(() => {});
			},
			handleSizeChange(val) {
				this.queryParams.pageSize = val;
				this.fetchData();
			},
			handleCurrentChange(val) {
				this.queryParams.pageNum = val;
				this.fetchData();
			},
			forMenuList() {
				this.isAgentSquare = false
				const MenuList = localStorage.getItem('MenuList')
				if (MenuList) {
					this.isAgentSquare = MenuList.includes('IntelligentAgentSquare')
				}
			},
			// 展示图本地上传
			handleViewLocalUpload(options) {
				const {
					file
				} = options;
				if (this.viewLocalUrl) URL.revokeObjectURL(this.viewLocalUrl);
				this.viewLocalUrl = URL.createObjectURL(file);
				this.allForm.form.promotionalImage = this.viewLocalUrl;
				this.agentViewFileList = [{
					url: this.viewLocalUrl
				}];
				this.$nextTick(() => this.$refs.formRef.validateField('form.promotionalImage'))
			},
			handleViewRemove() {
				this.allForm.form.promotionalImage = "";
				this.agentViewFileList = [];
				if (this.viewLocalUrl) {
					URL.revokeObjectURL(this.viewLocalUrl);
					this.viewLocalUrl = '';
				}
				this.$nextTick(() => this.$refs.formRef.validateField('form.promotionalImage'))
			},
			// 工作流图本地上传
			handleWorldLocalUpload(options) {
				const {
					file
				} = options;
				if (this.worldLocalUrl) URL.revokeObjectURL(this.worldLocalUrl);
				this.worldLocalUrl = URL.createObjectURL(file);
				this.allForm.form.designDrawing = this.worldLocalUrl;
				this.agentWorldFileList = [{
					url: this.worldLocalUrl
				}];
				this.$nextTick(() => this.$refs.formRef.validateField('form.designDrawing'))
			},
			handleWorldRemove() {
				this.allForm.form.designDrawing = "";
				this.agentWorldFileList = [];
				if (this.worldLocalUrl) {
					URL.revokeObjectURL(this.worldLocalUrl);
					this.worldLocalUrl = '';
				}
				this.$nextTick(() => this.$refs.formRef.validateField('form.designDrawing'))
			}
		},
		created() {
			this.forHtmlSimulation()
			this.forMenuList()
			this.info()
			this.fetchData();
			this.forModelTypeList();
			this.setFormRules()
		},
		beforeDestroy() {
			if (this.viewLocalUrl) URL.revokeObjectURL(this.viewLocalUrl);
			if (this.worldLocalUrl) URL.revokeObjectURL(this.worldLocalUrl);
		}
	}
</script>

<style scoped>
	.workflow {
		padding: 20px;
		background-color: #fff;
	}

	.search-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.search-left {
		display: flex;
		align-items: center;
	}

	/* 两个上传框同一行 */
	.upload-row-wrap {
		display: flex;
		gap: 20px;
	}

	.upload-col {
		flex: 1;
		margin-bottom: 0;
	}

	/* 卡片容器基础 */
	.picture-card-single {
		width: 148px;
		height: 148px;
		position: relative;
		border: 1px solid #dcdcdc;
		border-radius: 4px;
		overflow: hidden;
	}

	/* 删除按钮默认隐藏 */
	.del-icon {
		position: absolute;
		right: 8px;
		top: 8px;
		width: 20px;
		height: 20px;
		background: #fff;
		border-radius: 50%;
		text-align: center;
		line-height: 20px;
		cursor: pointer;
		display: none;
		z-index: 2;
	}

	/* 鼠标移入卡片，右上角显示删除图标 */
	.picture-card-single:hover .del-icon {
		display: block;
	}

	.html-config-btn {
		margin-left: 10px;
		padding: 7px 14px;
		border: 1px solid #409EFF;
		border-radius: 6px;
		background: #ecf5ff;
		color: #1f78d1;
		font-weight: 600;
		cursor: pointer;
	}

	.html-config-btn:hover {
		background: #409EFF;
		color: #fff;
	}
</style>